import React, { useEffect, useState } from 'react';
import './Privacy.css';
import { Helmet } from 'react-helmet';
import axios from 'axios';

const PrivacyPolicy = () => {
    const [metaTags, setMetaTags] = useState([]);

    useEffect(() => {
        const fetchMetaTags = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_BASE_URL}website/metaTags/privacy_policy`, {
                    headers: {
                        Accept: 'application/json',
                        'Client-Domain': process.env.REACT_APP_CLIENT_DOMAIN,
                    },
                });

                const htmlString = res.data?.metaTags || '';
                const doc = new DOMParser().parseFromString(htmlString, 'text/html');
                const tags = Array.from(doc.head.children);
                setMetaTags(tags);
            } catch (err) {
                console.error("Failed to fetch meta tags for Privacy Policy page", err);
            }
        };

        fetchMetaTags();
    }, []);

    const getMetaContent = (attr, value) => {
        const tag = metaTags.find(t => t.getAttribute(attr) === value);
        return tag?.getAttribute('content') || '';
    };

    return (
        <>
            <Helmet>
                <title>Privacy Policy - StreamPlay Network</title>

                {/* General Meta Tags */}
                <meta name="title" content={getMetaContent('name', 'title')} />
                <meta name="description" content={getMetaContent('name', 'description')} />
                <meta name="keywords" content={getMetaContent('name', 'keywords')} />
                <link rel="canonical" href={window.location.href} />

                {/* Open Graph Meta Tags */}
                <meta property="og:type" content={getMetaContent('property', 'og:type')} />
                <meta property="og:url" content={getMetaContent('property', 'og:url')} />
                <meta property="og:title" content={getMetaContent('property', 'og:title')} />
                <meta property="og:description" content={getMetaContent('property', 'og:description')} />
                <meta property="og:image" content={getMetaContent('property', 'og:image')} />

                {/* Twitter Meta Tags */}
                <meta name="twitter:card" content={getMetaContent('name', 'twitter:card')} />
                <meta name="twitter:url" content={getMetaContent('name', 'twitter:url')} />
                <meta name="twitter:title" content={getMetaContent('name', 'twitter:title')} />
                <meta name="twitter:description" content={getMetaContent('name', 'twitter:description')} />
                <meta name="twitter:image" content={getMetaContent('name', 'twitter:image')} />
            </Helmet>

            <div className="privacy-policy">
                <div className="privacy-container">
                    <h1>Privacy Policy</h1>
                    <p><strong>Last updated:</strong> April 9, 2025</p>

                    <p>
                        Welcome to <strong>StreamPlay Network</strong>
                        This Privacy Policy outlines how we collect, use, and protect your data while you're browsing our site.
                    </p>

                    <h2>1. Information We Collect</h2>
                    <p>We may collect the following types of data:</p>
                    <ul>
                        <li>Email address (only if you subscribe, comment, or contact us)</li>
                        <li>Anonymous analytics data (via tools like Google Analytics)</li>
                        <li>Browser type, device type, screen resolution, and approximate location</li>
                    </ul>

                    <h2>2. How We Use Your Information</h2>
                    <p>We use your information to:</p>
                    <ul>
                        <li>Improve user experience and site performance</li>
                        <li>Send newsletters or updates (only if you opt in)</li>
                        <li>Analyze traffic to understand which topics engage our readers</li>
                    </ul>

                    <h2>3. Cookies</h2>
                    <p>
                    StreamPlay Network uses cookies to personalize content, track usage patterns, and enhance performance. You can disable cookies via your browser, but some features may not work as intended.
                    </p>

                    <h2>4. Third-Party Services</h2>
                    <p>
                        We may integrate third-party services like Google Analytics, YouTube embeds, or social sharing buttons. These services may collect data based on their own privacy policies.
                    </p>

                    <h2>5. Data Protection</h2>
                    <p>
                        We value your privacy and implement appropriate technical and organizational measures to protect your personal information. However, no method of data transmission online is 100% secure.
                    </p>

                    <h2>6. Your Rights</h2>
                    <p>You may:</p>
                    <ul>
                        <li>Request access to or deletion of your personal information</li>
                        <li>Unsubscribe from emails at any time</li>
                        <li>Disable cookies via your browser</li>
                    </ul>

                    <h2>7. Updates to This Policy</h2>
                    <p>
                        We may revise this Privacy Policy from time to time. We encourage users to revisit this page periodically to stay informed about how we are protecting your information.
                    </p>

                    <h2>8. Contact Us</h2>
                    <p>
                        If you have any questions or feedback about this Privacy Policy, please contact us at:
                        <strong> <a href="mailto:info@treamplaynetwork.com">info@treamplaynetwork.com</a></strong>
                    </p>
                </div>

            </div>
        </>
    );
};

export default PrivacyPolicy;
